var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-success",staticStyle:{"padding-top":"44px"}},[_c('back-header',{attrs:{"title":"支付"}}),_c('img',{attrs:{"src":require("./bg@2x.png"),"alt":""}}),_c('h6',[_vm._v("支付成功")]),_c('p',[_vm._v("商家将尽快为您发货")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }